import React from 'react';
import { Section, Article, Heading, TextAccent, Link } from '../../../components';
import { Wrapper, Logo } from './SAP.style';
import logo from '../../../images/logo-sap.svg';

/**
 * Work: SAP composition.
 */
const SAP = () => (
  <Wrapper id="section:sap">
    <Section>
      <Article>
        <Heading element="h2" weight={500} colorKind="neutral">
          <Logo src={logo} alt="SAP logo" />
          <Link to="https://www.signavio.com/">SAP Signavio</Link>, helping enterprises transform and optimize their
          core processes with data-driven insight.
        </Heading>
        <TextAccent withSpacing>
          I joined SAP Signavio as a Development Expert to help build product features that enable enterprises to
          understand, govern, and continuously improve their processes.
        </TextAccent>
        <TextAccent withSpacing>
          My recent focus has been on leading the access management initiative to establish a robust, scalable
          permissions model across our platform, and driving AI adoption on my team; identifying where AI can
          meaningfully streamline our workflows and bringing the team along through hands-on experimentation, knowledge
          sharing, and practical tooling. On top of that, I’ve been building the analytics layer and developing
          collaborative features like a rich text editor and attachment support for commenting, I also push for stronger
          team practices around documentation, technical discussions, and how we work together.
        </TextAccent>
        <TextAccent>
          <strong>Technologies we use:</strong> TypeScript, Java/Kotlin, AWS, GraphQL, Docker, Web Components,
          Storybook, Jest, Cypress.
        </TextAccent>
      </Article>
    </Section>
  </Wrapper>
);

export default SAP;
